module.exports = __webpack_public_path__ + "img/camera.3c94be87.svg";